import React from 'react';
import { categoryMeta } from '../data/budgetItems';
import { formatCurrency } from '../utils/calculations';

function BudgetSummary({ calculations, budgetCap, settings }) {
  const spendPercent =
    budgetCap > 0 ? Math.min((calculations.total / budgetCap) * 100, 100) : 0;
  const isOver = calculations.remaining < 0;

  return (
    <aside className="summary-card">
      <span className="summary-kicker">Live budget summary</span>
      <h2>{formatCurrency(calculations.total)}</h2>
      <p>
        {settings.city}, {settings.country} · Total estimated investment
      </p>

      <div className="summary-location">
        <span>Destination adjustment</span>
        <strong>
          {settings.locationAdjustment >= 0 ? '+' : ''}
          {settings.locationAdjustment}%
        </strong>
      </div>

      <div className="budget-progress">
        <div>
          <span>Budget utilization</span>
          <strong>{spendPercent.toFixed(1)}%</strong>
        </div>
        <div className="progress-track">
          <span
            className={isOver ? 'over' : ''}
            style={{ width: `${spendPercent}%` }}
          />
        </div>
        <small className={isOver ? 'negative' : 'positive'}>
          {isOver
            ? `${formatCurrency(Math.abs(calculations.remaining))} over budget`
            : `${formatCurrency(calculations.remaining)} remaining`}
        </small>
      </div>

      <div className="category-breakdown">
        <h3>Category allocation</h3>
        {Object.entries(categoryMeta).map(([category, meta]) => {
          const value = calculations.categories[category] || 0;
          const percent =
            calculations.grossSubtotal > 0
              ? (value / calculations.grossSubtotal) * 100
              : 0;

          return (
            <div className="category-row" key={category}>
              <div className="category-label">
                <i style={{ backgroundColor: meta.color }} />
                <span>{category}</span>
              </div>
              <strong>{formatCurrency(value)}</strong>
              <div className="mini-track">
                <span
                  style={{
                    backgroundColor: meta.color,
                    width: `${percent}%`
                  }}
                />
              </div>
            </div>
          );
        })}
      </div>

      <div className="summary-ledger">
        <div>
          <span>Media subtotal</span>
          <strong>{formatCurrency(calculations.grossSubtotal)}</strong>
        </div>
        <div className="discount-row">
          <span>Package discount</span>
          <strong>−{formatCurrency(calculations.discount)}</strong>
        </div>
        <div>
          <span>Contingency reserve</span>
          <strong>{formatCurrency(calculations.contingency)}</strong>
        </div>
        <div>
          <span>Estimated tax and fees</span>
          <strong>{formatCurrency(calculations.tax)}</strong>
        </div>
        <div className="ledger-total">
          <span>Estimated total</span>
          <strong>{formatCurrency(calculations.total)}</strong>
        </div>
      </div>
    </aside>
  );
}

export default BudgetSummary;